// extracted by mini-css-extract-plugin
export var productImage = "_n4-0";